
      <div class="row">
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">All Needs</h4>
              <h2 class="text-end"><span class="float-start">{{ allNeeds }}</span><i class="fas fa-ticket-alt"></i></h2>
              <p class="m-b-0">Navigate To All Needs</p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">Pending Needs</h4>
              <h2 class="text-end"><span class="float-start">{{ pendingNeeds }}</span><i class="far fa-check-circle"></i></h2>
              <p class="m-b-0">Navigate To Pending Needs</p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">Approved Needs</h4>
              <h2 class="text-end"><span class="float-start">{{ approvedNeeds }}</span><i class="fas fa-briefcase"></i></h2>
              <p class="m-b-0">Navigate To Approved Needs</p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">Rejected Needs</h4>
              <h2 class="text-end"><span class="float-start">{{ rejectedNeeds }}</span><i class="fas fa-umbrella-beach"></i></h2>
              <p class="m-b-0">Navigate To Approved Needs</p>
            </div>
          </div>
        </div>
      </div>
      
     
    